<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" @submit="submit">
        <template #title>
            {{ i18n('Reset password') }}
            <span class="h6" v-if="user">
               ({{ user.first_name }} {{ user.last_name }})
            </span>
        </template>
        <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
        </div>

        <div class="col-12 label-small">
            <Field :label="i18n('Password')" type="password" placeholder="" v-model="formData.password" :required="true"
                :disabled="submitted" :errorMessage="errorMessages.password" />
        </div>
        <div class="col-12 label-small">
            <Field :label="i18n('Repeat Password')" type="password" placeholder="" :disabled="submitted"
                :required="true" v-model="formData.repeat_password" :errorMessage="errorMessages.repeat_password" />
        </div>

        <div class="p-3 border rounded">
            <UserPolicyResetPassword />
        </div>

        <template #footer>
            <div class="row">
                <div class="col text-end">
                    <button type="submit" class="btn btn-dark btn-sm" :disabled="submitted">
                        {{ i18n('Save') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>
import api from "@/api.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import UserPolicyResetPassword from "@/components/user/UserPolicyResetPassword.vue";
import { duplicate } from '@/tools/object.js';
import { translatedErrorMessage } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
        FieldReadonly,
        UserPolicyResetPassword,
    },
    data() {
        return {
            submitted: false,
            formData: {},
            errorMessage: '',
            errorMessages: {},
            user: {},
        };
    },
    props: {},
    emits: [
        'shown',
        'hidden',
        'submit',
        'updated',
    ],
    methods: {
        show(user_id) {
            this.errorMessage = '';
            this.errorMessages = {};
            this.user = {};
            this.submitted = false;
            this.formData = {};

            api.get(`users/${user_id}`).then((user) => {
                this.user = user;
                this.$refs['modal'].show();
            }).catch((error) => {
                this.errorMessage = error.message;
            });
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.errorMessage = '';
            this.submitted = true;

            if (this.formData.password !== this.formData.repeat_password) {
                this.errorMessages.repeat_password = this.i18n('Passwords do not match');
                return;
            }

            const postFormData = duplicate(this.formData);

            api.post(`users/${this.user.id}/updateAdPassword`, postFormData).then(() => {
                this.$emit('submit', this.user.id);
                this.hide();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage, {
                    'Bad Request': 'Password change failed.',
                });
                this.submitted = false;
            });
        },
    }
};
</script>